import ApiService from '@/services/core/api.service'

const NewAccountService = {
  async get (query) {
    return ApiService.get(`collection/new-accounts?${query}`)
  },

  async post (payload) {
    return ApiService.post('collection/new-accounts', payload)
  },

  async put (payload) {
    return ApiService.put(`collection/new-accounts/${payload.id}`, payload)
  }
}

export default NewAccountService
